export const EVENT_PREFIX_NAME = "gamebiz_";

export const EVENT_NAME_IMPRESSION = `${EVENT_PREFIX_NAME}impression`;
export const EVENT_NAME_CLICK = `${EVENT_PREFIX_NAME}click`;

export const EVENT_DATA_TYPE_ADVERTISEMENT = "advertisement";
export const EVENT_DATA_TYPE_JOB = "job";
